export default (eventName, data) => {

    const body = document.querySelector('body');
    if (body) {
        const event = new Event(eventName);
        event.data = data;
        body.dispatchEvent(event);
    }

}
